import {Status} from '../enum/status.enum';

export class ClinicListItem
{
    public readonly id: string;

    public readonly name: string;

    public readonly status: Status;
    
    public readonly picture: string;

    public readonly totalClinicians: number;

    public constructor(
        id: string,
        name: string,
        status: Status,
        picture: string,
        totalClinicians: number
    )
    {
        this.id = id;
        this.name = name;
        this.status = status;
        this.picture = picture;
        this.totalClinicians = totalClinicians;
    }

    public static fromJSON(clinicListJSON: any): ClinicListItem
    {
        return new ClinicListItem(
            clinicListJSON.id,
            clinicListJSON.name,
            clinicListJSON.status,
            clinicListJSON?.picture ?? 'assets/images/clinic_placeholder.webp',
            clinicListJSON?.totalClinicians ?? 0
        );
    }
}
